import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs';

function OilGas() {
    // const page = "oilgas";
  const page = "industry";
  return (
    <div>
        <section className={`hero ${page}`}>
            <h1>Oil and Gas</h1>
        </section>

        {/* <nav className="breadcrumbs" aria-label="Breadcrumb">
        <ol className="breadcrumbs__list">
            <li className="breadcrumbs__item"><a href="/">Home</a></li>
            <li className="breadcrumbs__item"><a href="/solutions">Solutions</a></li>
            <li className="breadcrumbs__item" aria-current="page">oil-gas</li>
        </ol>
        </nav>   */}
        <Breadcrumbs
            items={[
                { label: "Home", to: "/" },
                { label: "Solutions", to: "/solutions" },
                { label: "oil-gas" }, // no `to` = current page
        ]}
        />

        <section className="split-about">
        <div className="split-about__wrap">
            <div className="split-about__content">
            <p>
                The oil and gas industry remains the backbone of the global energy system, fueling economies and providing essential raw materials for 
                countless industries. From upstream exploration to downstream refining, this sector faces immense pressure to maximize efficiency, maintain 
                well integrity, and meet strict environmental regulations. Operators must manage complex drilling environments, prevent costly downtime, 
                and ensure safety in every stage of production.
            </p>
            </div>


            <figure className="split-about__media">
            <img src="/assets/images/industry/oil-gas.png" alt="Application film rolls" />
            </figure>

        </div>
        </section>

        <section className="applications">
        <div className="applications__wrap">
            <h1>Our Solutions:</h1>

            <ul className="applications__list">
            <li><strong>Drilling Fluids & Additives</strong>: MD-BAR (barite) for density control, MD-BENT for borehole sealing, MD-OILGEL for cuttings suspension and filtration control.</li>
            <li><strong>Wellbore Strengthening & Lost Circulation</strong>: MD-CAR and SEAL-LUBE to prevent seepage and control losses in even HP/HT wells.</li>
            <li><strong>Cementing Solutions</strong>: ECDGUARD spacers protect formations during cement placement.</li>
            </ul>

            <p>
            </p>
        </div>
        </section>        
    </div>
  )
}

export default OilGas